import { inject, Injectable } from '@angular/core';
import { PlexEnvironment } from '@app/env';
import { ApplicationInsights, IConfiguration, IEventTelemetry, IPageViewTelemetry } from '@microsoft/applicationinsights-web';

@Injectable({
  providedIn: 'root'
})
export class AppInsightsService {
  public environment = inject(PlexEnvironment);
  private appInsights: ApplicationInsights | null = null;

  public config: IConfiguration = {
    instrumentationKey: this.environment.appInsights.instrumentationKey
  };

  private Init() {
    if (!this.appInsights) {
      this.appInsights = new ApplicationInsights({ config: this.config });
      this.appInsights.loadAppInsights();
    }
  }

  public LogPageView(name: string, url?: string, properties?: any, measurements?: any) {
    this.Init();
    const pageViewTelemetry: IPageViewTelemetry = {
      name: name,
      uri: url,
      properties: properties,
      measurements: measurements,
    };
    this.appInsights.trackPageView(pageViewTelemetry);
  }

  public LogEvent(name: string, properties?: any, measurements?: any) {
    this.Init();
    const eventTelemetry: IEventTelemetry = {
      name: name,
      properties: properties,
      measurements: measurements,
    };
    this.appInsights.trackEvent(eventTelemetry);
  }
}